import { render } from "./PaymentInfo.vue?vue&type=template&id=564f6181&ts=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts"

import "./PaymentInfo.vue?vue&type=style&index=0&id=564f6181&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__